import styled from '@/styles';

// ui-prototype/preferred-worker-pool/client-detail.html #subtabPoolMembers /
// #subtabNominations (+#nominationsBadge). The prototype's Favorites and
// Activity subtabs are NOT ported — they have no backend in GRAVY-10265
// (recorded as prototype deltas alongside staffing deltas C/D/E).

export type PoolTabValue = 'members' | 'nominations';

const TabList = styled('div', {
  display: 'flex',
  alignItems: 'center',
  borderBottom: '1px solid #DADADA',
});

const TabButton = styled('button', {
  all: 'unset',
  height: 44,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  padding: '0 16px',
  fontSize: '14px',
  fontWeight: 400,
  color: '#3C3C3C',
  borderBottom: '3px solid transparent',
  cursor: 'pointer',
  variants: {
    active: {
      true: {
        color: '#1C1C1C',
        fontWeight: 700,
        borderBottomColor: '#45A735',
      },
    },
  },
});

const Badge = styled('span', {
  background: 'rgba(231,244,230,0.24)',
  border: '1px solid #A7DAA1',
  borderRadius: 8,
  width: 20,
  height: 20,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  fontWeight: 700,
  color: '#44A735',
});

type Props = {
  tab: PoolTabValue;
  pendingCount: number;
  onTab: (tab: PoolTabValue) => void;
};

const PoolTabs = ({ tab, pendingCount, onTab }: Props) => (
  <TabList role="tablist">
    <TabButton
      active={tab === 'members'}
      aria-selected={tab === 'members'}
      data-testid="subtabPoolMembers"
      role="tab"
      type="button"
      onClick={() => onTab('members')}
    >
      Pool members
    </TabButton>
    <TabButton
      active={tab === 'nominations'}
      aria-selected={tab === 'nominations'}
      data-testid="subtabNominations"
      role="tab"
      type="button"
      onClick={() => onTab('nominations')}
    >
      Pending nominations{' '}
      <Badge data-testid="nominationsBadge">{pendingCount}</Badge>
    </TabButton>
  </TabList>
);

export default PoolTabs;
